// extracted by mini-css-extract-plugin
module.exports = {"root__div":"PageHeader_root__div__22kLp","separator":"PageHeader_separator__2Qvpn"};